import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import { addDotBtnsAndClickHandlers, addPrevNextBtnsClickHandlers, setupProgressBar } from '../utils/emblaUtils'
import breakpoints from '../data/breakpoints';

export default function init() {

	document.querySelectorAll('.js-testimonials-slider').forEach((slider) => {
		
		const instance = EmblaCarousel(
			slider, 
			{
				playOnInit: true,
				loop: true,
				delay: 6000,
			}, 
			[Autoplay()],
		)

		addDotBtnsAndClickHandlers(
			instance,
			slider.querySelector('.embla__dots'),
		)
	});

	document.querySelectorAll('.js-card-slider').forEach((slider) => {
		
		const instance = EmblaCarousel(
			slider, 
			{
				playOnInit: true,
				loop: true
			}, 
			[Autoplay()],
		)

		addDotBtnsAndClickHandlers(
			instance,
			slider.querySelector('.embla__dots'),
		)
	});

	document.querySelectorAll('.js-gallery-slider').forEach((slider) => {
		
		const instance = EmblaCarousel(
			slider, 
			{
				playOnInit: true,
				loop: true,
			}, 
			[Autoplay()],
		)

	});

	document.querySelectorAll('.js-team-slider').forEach((slider) => {
		
		const instance = EmblaCarousel(
			slider, 
			{
				playOnInit: true,
				align: 'start',
			}, 
			[],
		)

		addDotBtnsAndClickHandlers(
			instance,
			slider.querySelector('.embla__dots'),
		)

	});

	document.querySelectorAll('.js-featured-slider').forEach((slider) => {

		const bp = {};
		bp[`(min-width: ${breakpoints['responsive-featured']}px)`] = {
			active: false,
		};
		
		const instance = EmblaCarousel(
			slider, 
			{
				playOnInit: true,
				loop: true,
				breakpoints: bp,
			}, 
			[Autoplay()],
		)

		const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
			instance,
			slider.querySelector('.embla__dots'),
		)

		instance.on('destroy', removeDotBtnsAndClickHandlers)

	});

	document.querySelectorAll('.js-discover-slider').forEach((slider) => {

		const bp = {};
		bp[`(max-width: ${breakpoints['responsive-discover']}px)`] = {
			active: false,
		};

		const prevBtn = slider.querySelector('.embla__button--prev')
		const nextBtn = slider.querySelector('.embla__button--next')
		const progressNode = slider.querySelector('.embla__progress__bar')
		
		const instance = EmblaCarousel(
			slider, 
			{
				align: 'start',
				loop: false,
				breakpoints: bp,
			},
		);

		if (progressNode) {
			const { applyProgress, removeProgress } = setupProgressBar(
				instance,
				progressNode
			)

			instance
				.on('init', applyProgress)
				.on('reInit', applyProgress)
				.on('scroll', applyProgress)
				.on('slideFocus', applyProgress)
				.on('destroy', removeProgress)
		}

		if (prevBtn && nextBtn) {
			const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
				instance,
				prevBtn,
				nextBtn
			)

			instance.on('destroy', removePrevNextBtnsClickHandlers)
		}
	});

}